var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path, _line8, _line9, _line0, _line1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLineMeasureSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.43826,
    y: 1.47341,
    width: 14.6446,
    height: 5.63255,
    rx: 1.01386,
    stroke: "white",
    strokeWidth: 1.12651
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.25466,
    y1: 4.24001,
    x2: 4.25466,
    y2: 6.49303,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.50857,
    y1: 4.24001,
    x2: 6.50857,
    y2: 6.49303,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.76247,
    y1: 4.24001,
    x2: 8.76247,
    y2: 6.49303,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.0125,
    y1: 4.24001,
    x2: 11.0125,
    y2: 6.49303,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 13.2664,
    y1: 4.24001,
    x2: 13.2664,
    y2: 6.49303,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 2.05711,
    y1: 8.9151,
    x2: 2.03469,
    y2: 14.5526,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 15.6001,
    y1: 8.9151,
    x2: 15.5777,
    y2: 14.5526,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 11.7314L13.5824 11.7314",
    stroke: "white",
    strokeWidth: 0.901209
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 11.988,
    y1: 10.1406,
    x2: 13.5811,
    y2: 11.7338,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0.563255,
    y1: -0.563255,
    x2: 2.81628,
    y2: -0.563255,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 11.1914 13.3223)",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 5.53937,
    y1: 13.3223,
    x2: 3.94625,
    y2: 11.7291,
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 0.563255,
    y1: -0.563255,
    x2: 2.81628,
    y2: -0.563255,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 6.33594 10.1406)",
    stroke: "white",
    strokeWidth: 1.12651,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLineMeasureSelected);
export default __webpack_public_path__ + "static/media/ico_line_measure_selected.752dd353f48646ffdc6f8b413d0191a8.svg";
export { ForwardRef as ReactComponent };